import { CardCart, CardCartProps } from "components/Cards/CardCart";
import { CfCardCartProps } from "components/Cards/CardCart/CfCardCart/schema";
import { MarkdownCheckList } from "components/MarkdownCheckList";
import { convertToPolyLink } from "components/Anchor/utils";
import CfAnchor from "components/Anchor";
import CfStickyElement from "components/StickyElement/CfStickyElement";
import React, { ReactNode } from "react";
import recursiveRender from "utilities/recursiveRender";

const convertCfCardCartProps = ({
  orderDetails,
  promoInfo,
  oldPrice,
  priceDetail,
  ctaAnchor,
  ...otherProps
}: CfCardCartProps) => {
  const defails = (
    <MarkdownCheckList>{orderDetails.orderDetails}</MarkdownCheckList>
  );

  const props: CardCartProps = {
    ...otherProps,
    ctaAnchor: (children: ReactNode) => (
      <CfAnchor {...ctaAnchor}>{children}</CfAnchor>
    ),
    orderDetails: defails,
    promoInfo: promoInfo && recursiveRender({ cfComponent: promoInfo }),
    oldPrice: <del>{oldPrice}</del>,
    priceDetail: priceDetail ?? undefined,
  };

  return props;
};

const CfCardCart = (props: CfCardCartProps) => {
  return (
    <>
      <CardCart {...convertCfCardCartProps(props)} />
      <CfStickyElement
        ctaAnchor={props.ctaAnchor}
        ctaLabel={props.ctaLabel}
        price={props.price}
        description={props.priceDetail}
        title={props.summaryLabel}
        theme={null}
      />
    </>
  );
};

export default CfCardCart;
